<div [class.cursor-pointer]="showFullOnClick" (mouseenter)="hovered= true" (mouseleave)="hovered=false"
     [title]="title? mediaInfos() : ''">
  <div *ngIf="background">
    <div [ngbTooltip]="hoverPreview ? hover : null"
         container="body" openDelay="500" closeDelay="500"
         placement="{{hoverPlacement? hoverPlacement+' right top-right top':'right top-right top'}}">
      <div *ngIf="medium && medium.contentType"
           [ngStyle]="{'height': customHeight, 'width': customWidth }"
           [class.caption-style]="showFullOnClick"
           [class]="'picBg ' + classes" [style.background-image]="backgroundURL(medium)">
        <div *ngIf="showFullOnClick" class="caption">
          <div class="blur"></div>
          <div class="caption-text">
            <h1>
              <sb-icon icon="preview" class="white"></sb-icon>
            </h1>
          </div>
        </div>
        <!--
        <div [ngClass]="{'overlay': hovered, 'hide': !hovered}">
        </div>
        -->
      </div>
      <div *ngIf="!medium || !medium.contentType">
        <ng-container [ngTemplateOutlet]="noMedium"></ng-container>
      </div>
    </div>
  </div>
  <div *ngIf="!background">
    <div [ngbTooltip]="hoverPreview ? hover : null"
         container="body" openDelay="500" closeDelay="500"
         placement="{{hoverPlacement? hoverPlacement+' right top-right top':'right top-right top'}}">
      <ng-container [ngTemplateOutlet]="component">
      </ng-container>
    </div>
  </div>
</div>

<!--

Component

-->
<ng-template #component>
  <div *ngIf="medium && medium.contentType && !medium.processing"
       [ngStyle]="{'height': customHeight, 'width': customWidth }"
       [class.caption-style]="showFullOnClick"
       [ngSwitch]="true" class="picBg">
    <img
      style="width:100%; height: 100%; border-radius: 4px;"
      [class]="'imageBg '+ classes"
      *ngSwitchCase="medium.contentType.indexOf('image') !== -1"
      src="{{url(medium!)}}" alt="{{medium.name}}"/>
    <ng-container
      *ngSwitchCase="medium.contentType.indexOf('video') !== -1">
      <video
        *ngIf="!still"
        #videoElement
        [muted]="muted"
        [class]="classes"
        (ended)="videoEnded.emit()"
        autoplay playsinline [controls]="controls" loop style="width:100%; height: 100%; border-radius: 4px;"
        src="{{url(medium!)}}">
        {{'lang.globals.noSupportHTMLVideo' | translate}}
      </video>
      <img
        *ngIf="still"
        [class]="'imageBg '+ classes"
        src="{{medium.stillImage}}" alt="{{medium.name}}"/>
    </ng-container>
    <img
      style="width:100%; height: 100%; border-radius: 4px;"
      *ngSwitchCase="medium.contentType.indexOf('text') !== -1"
      [class]="'imageBg ' + classes"
      src="{{medium.stillImage}}" alt="{{medium.name}}"/>
    <div *ngIf="showFullOnClick" class="{{classes}} caption">
      <div class="blur"></div>
      <div class="caption-text">
        <h1>
          <sb-icon icon="preview" class="white"></sb-icon>
        </h1>
      </div>
    </div>
  </div>
  <div *ngIf="!medium || !medium.contentType">
    <ng-container [ngTemplateOutlet]="noMedium"></ng-container>
  </div>
  <div *ngIf="medium && medium.contentType && medium.processing">
    <ng-container [ngTemplateOutlet]="processing"></ng-container>
  </div>
</ng-template>

<!--

Hover

-->
<ng-template #hover>
  <div *ngIf="medium && medium.contentType && !medium.processing"
       style="width: 100%; height: 100%"
       [ngSwitch]="true">
    <img
      [class]="classes"
      style="width: 100%; height: 100%"
      *ngSwitchCase="medium.contentType.indexOf('image') !== -1"
      src="{{url(medium)}}" alt="{{medium.name}}"/>
    <ng-container
      *ngSwitchCase="medium.contentType.indexOf('video') !== -1">
      <video
        *ngIf="!still"
        [class]="classes"
        autoplay playsinline [controls]="controls"
        muted loop onloadedmetadata="this.muted=true" style="width: 100%; height: 100%; border-radius: 4px;"
        src="{{url(medium!)}}">
        {{'lang.globals.noSupportHTMLVideo' | translate}}
      </video>
      <img
        *ngIf="still"
        [class]="classes"
        style="width: 100%; height: 100%"
        src="{{medium.stillImage}}" alt="{{medium.name}}"/>
    </ng-container>
  </div>
  <div *ngIf="!medium || !medium.contentType">
    <ng-container [ngTemplateOutlet]="noMedium"></ng-container>
  </div>
  <div *ngIf="medium && medium.contentType && medium.processing">
    <ng-container [ngTemplateOutlet]="processing"></ng-container>
  </div>
</ng-template>

<!--

No Medium

-->
<ng-template #noMedium>
  <div *ngIf="background"
       [ngStyle]="{'height': customHeight, 'width': customWidth }"
       class="picBg picBg--small d-flex align-items-center justify-content-center question-mark-bg"
       [ngbTooltip]="translate.instant('lang.globals.noMedium')"
       placement="right top-right top" container="body"
       [class]="hoverPreview? classes: ''">
    <span class="font-weight-bold">?</span>
  </div>
  <img *ngIf="!background"
       [ngStyle]="{'height': customHeight, 'width': customWidth }"
       [ngbTooltip]="translate.instant('lang.globals.noMedium')"
       placement="right top-right top" container="body"
       [class]="hoverPreview? classes: ''"
       src="/assets/img/base_file.svg" alt="missing image"/>
</ng-template>

<!--

Processing

-->
<ng-template #processing>
  <div [class]="'picBg '+ hoverPreview? classes: ''">
    <sb-icon class="mr-2" icon="loadingCircleAnimation" [animationOptions]="{autoplay: true, loop:true}"
             [style.color]="'#004F90'">
    </sb-icon>
    {{'lang.mediumExplorer.processing' | translate}}
  </div>
</ng-template>
